import React, { useEffect } from "react";
import "./layouts.css";
import { Outlet, useLocation, useNavigate } from "react-router";
// import SideNav from "../nav/SideNav";
import TopBar from "../nav/TopBar";
import DashNav from "../nav/DashNav";
import useEstates from "../../hooks/useEstates";
import { AxiosAuthGet } from "../../api/api";

const DashLayout = () => {
  const navigate = useNavigate();
  const estUrl = `developer/estates/`;

  // const [isDev, setIsDev] = useState(false);
  const pathname = useLocation().pathname;
  const { setEstatesArr } = useEstates();


  const checkActiveUser = () => {
    const user = JSON.parse(localStorage.getItem("apk"));
    if (user) {
      if (user?.data?.accountType === "Agent") {
        navigate("/agent/overview");
      }
    }
    if (!user?.data?.accountType && user?.data?.accountType !== "Developer") {
      navigate("/auth/signin");
    }
    // console.log(user);
  };

  const getEst = () => {
    AxiosAuthGet(estUrl)
      .then((res) => {
        // console.log(res);
        setEstatesArr(res?.data);
        // setIsELoading(false);
      })
      .catch((err) => {
        // console.log(err.response);
        // setIsELoading(false);
      });
  };

  useEffect(() => {
    checkActiveUser();
    getEst();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    // eslint-disable-next-line
  }, [pathname]);

  return (
    <div className="agent-layout">
      <div className="agent-layout_left">
        <DashNav />
      </div>
      <div className="agent-layout_right">
        <TopBar />
        <Outlet />
      </div>
    </div>
  );
};

export default DashLayout;
